import script from "./ListNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./ListNotification.vue?vue&type=script&setup=true&lang=js"

import "./ListNotification.vue?vue&type=style&index=0&id=061aa131&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/evyd/Prod/client-unn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-061aa131"]])

export default __exports__